import { render, staticRenderFns } from "./membercardLead.vue?vue&type=template&id=752d19f6&scoped=true"
import script from "./membercardLead.vue?vue&type=script&lang=js"
export * from "./membercardLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d19f6",
  null
  
)

export default component.exports